const currencySymbols = new Map();
currencySymbols.set('USD', '$');
currencySymbols.set('EUR', '€');
currencySymbols.set('GBP', '£');
currencySymbols.set('JPY', '¥');
currencySymbols.set('CNY', '¥');
currencySymbols.set('AUD', 'A$');

export { currencySymbols };